import { ActionTypes } from 'modules/experiments/takeover/ducks/actionTypes';
import {
  CampaignInfoState,
  OriginalExperimentState,
  ExperimentTakeoverMetaData,
} from 'modules/experiments/takeover/types';

export const openExperimentModal = (payload: CampaignInfoState) => ({
  type: ActionTypes.MODAL_OPEN,
  payload,
});

export const openExperimentDrawer = (experimentId: number) => ({
  type: ActionTypes.DRAWER_OPEN,
  experimentId,
});

export const openExperimentDrawerWithData = (payload: OriginalExperimentState) => ({
  type: ActionTypes.DRAWER_OPEN_WITH_DATA,
  payload,
});

export const closeExperimentModal = () => ({
  type: ActionTypes.MODAL_CLOSE,
});

export const closeExperimentDrawer = () => ({
  type: ActionTypes.DRAWER_CLOSE,
});

export const setExperimentSource = (payload: ExperimentTakeoverMetaData['source']) => ({
  type: ActionTypes.SET_SOURCE,
  payload,
});
